<template>
  <GlobalWindow
    :visible.sync="isVisibled"
    :show="false"
    title="复制列表"
    width="80%"
  >
    <div class="app-container">
      <el-card style="box-shadow: none; border: none">
        <div class="top">
          <el-row :gutter="10">
            <el-button
              type="danger"
              @click="againMpAdvertList"
            >任务重试</el-button>
          </el-row>
        </div>
        <div class="main">
          <el-table
            v-loading="loading"
            :data="mpAdvertList"
            style="width: 100%"
            :row-key="getRowKeys"
            @select="multipleChoice"
            @select-all="multipleChoice"
          >
            <el-table-column prop="id" label="记录id" align="center" width="80px" />
            <el-table-column prop="job_id" label="任务id" align="center" width="80px" />
            <el-table-column
              prop="source_sub_uc_id"
              label="来源子账户id"
              align="center"
              width="80"
            />
            <el-table-column
              prop="source_campaignFeedId"
              label="来源计划id"
              align="center"
              width="80"
            />
            <el-table-column
              prop="target_sub_uc_id"
              label="目标子账户id"
              align="center"
              width="80"
            />
            <el-table-column
              prop="target_campaignFeedId"
              label="目标计划id"
              align="center"
              width="80"
            />
            <el-table-column
              prop="target_campaignFeedName"
              label="目标计划名称"
              align="center"
              width="100"
            />
            <el-table-column
              label="目标广告创意id(名称)"
              align="center"
              width="180"
            >
              <template scope="scope">
                <el-tag
                  v-for="(item,index) in scope.row.target_creative"
                  :key="index"
                  :type="index % 2 === 0 ? 'primary' : 'success'"
                >
                  <span
                    v-for="creative in item.creativeFeed"
                    :key="creative.creativeFeedId"
                  >
                    {{ creative.creativeFeedId }}({{ creative.creativeFeedName }})
                  </span>
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column
              label="推广单元id(创意名称)"
              align="center"
              width="280"
            >
              <template scope="scope">
                <el-tag
                  v-for="(item,index) in scope.row.target_creative"
                  :key="index"
                  :type="index % 2 === 0 ? 'primary' : 'success'"
                >
                  {{ item.adgroupFeedId }}({{ item.adgroupFeedName }})
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column
              prop="fail_reason"
              label="失败原因"
              align="center"
              width="280"
            />
            <el-table-column prop="status" label="状态" align="center">
              <template scope="scope">
                {{
                  scope.row.status == 1
                    ? '成功'
                    : scope.row.status == 2
                      ? '失败'
                      : scope.row.status == 3
                        ? '终止'
                        : '待处理'
                }}
              </template></el-table-column>
            <el-table-column
              prop="updated_at"
              label="更新时间"
              align="center"
            />
            <el-table-column
              prop="created_at"
              label="创建时间"
              align="center"
            />
          </el-table>
          <Pagination
            :total="pageTotal"
            :page.sync="mpAdvertListParams.page"
            :limit.sync="mpAdvertListParams.page_size"
            :page-sizes="[mpAdvertListParams.page_size]"
            @pagination="fetchMpAdvertList"
          />
        </div>
      </el-card>
    </div>
  </GlobalWindow>
</template>
<script>
import Pagination from '@/components/Pagination/index'
import { job_record_list, retryFailedRecord } from '@/api/baiduAD'
import GlobalWindow from '@/components/GlobalWindow.vue'
export default {
  name: 'CopyMpAdvertManage',
  components: {
    Pagination,
    GlobalWindow
  },
  data() {
    return {
      isVisibled: false,
      loading: false,
      drawerTitle: null,
      pageTotal: 0,
      isDetailStatus: false,
      mpAdvertListParams: {
        job_id: null,
        page: 1,
        page_size: 10
      },
      mpAdvertList: [],
      isShow: false
    }
  },
  created() {},
  methods: {
    multipleChoice(arr) {
      this.adgroup_ids = arr.map((item) => {
        return item.adgroup_id
      })
      this.adgroup_items = arr
    },
    // 获取广告列表
    fetchMpAdvertList() {
      this.loading = true
      this.isShow = false
      job_record_list(this.mpAdvertListParams).then((res) => {
        this.mpAdvertList = res.data.list
        this.pageTotal = res.data.total
        this.loading = false
      })
    },
    getRowKeys(row) {
      return row.id
    },
    // 重置广告列表
    resetMpAdvertList() {
      this.mpAdvertListParams = {
        job_id: null,
        page: 1,
        page_size: 10
      }
      this.fetchMpAdvertList()
    },
    open(item) {
      this.isVisibled = true
      this.mpAdvertListParams.job_id = item.id
      this.fetchMpAdvertList()
    },
    againMpAdvertList() {
      if (this.mpAdvertList.length === 0) {
        this.$message.error('当前没有任务记录')
        return
      }
      const job_ids = []
      job_ids.push(this.mpAdvertList[0].job_id)
      retryFailedRecord({ job_ids: job_ids }).then(res => {
        this.$message.info(res.message)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.header {
  display: flex;
  justify-content: space-between;
}
.main {
  margin-top: 20px;
  video {
    width: 100px;
    height: 100px;
    object-fit: fill;
  }
  .shadowBox {
    display: flex;
    height: 100px;
    align-items: center;
    justify-content: center;
  }
}
.app-container {
  padding: 0px;
}
</style>
